// Module
var code = "<template> <div class=\"h-100 d-flex flex-column justify-content-center\"> <b>${today | formatDate:dateFormat}</b> <span class=\"font-size-2xl\"> ${today | formatDate:timeFormat} <span class=\"font-size-lg\"> ${timeZone} </span> </span> </div> </template> ";
// Exports
export default code;